import { Button } from '@eureca/ui';
import { ConsultantsMenu } from '@/shared/consultants-menu/ConsultantsMenu';
import { TriangleAlertIcon } from './icons';

export interface JobEditCompensationErrorFallbackProps {
  onRetry: () => void;
}

/**
 * Fallback exibido quando o `GET /jobs/:id` falha por motivo ≠ 404
 * (EU-161 FR-081b). 404 já é tratado no container com toast + redirect;
 * aqui cobrimos 500, 502, falhas de rede etc.
 */
export function JobEditCompensationErrorFallback({
  onRetry,
}: JobEditCompensationErrorFallbackProps) {
  return (
    <div className="flex min-h-dvh flex-row bg-muted">
      <ConsultantsMenu activeId="jobs" />

      <main className="flex flex-1 flex-col items-center justify-center gap-8 bg-card px-8 py-16">
        <div role="alert" className="flex w-full max-w-[480px] flex-col items-center gap-5">
          <div
            aria-hidden="true"
            className="flex h-16 w-16 items-center justify-center rounded-full bg-muted"
          >
            <TriangleAlertIcon className="h-6 w-6 text-foreground" />
          </div>
          <div className="flex flex-col items-center gap-2 text-center">
            <h2 className="text-2xl font-semibold leading-none tracking-tight text-foreground">
              Não foi possível carregar a seção de remuneração
            </h2>
            <p className="text-base leading-normal text-muted-foreground">
              Houve um problema ao buscar os dados desta vaga. Tente novamente em alguns instantes.
            </p>
          </div>
          <Button
            type="button"
            size="lg"
            onClick={onRetry}
            data-testid="job-edit-compensation-error-retry"
          >
            Tentar novamente
          </Button>
        </div>
      </main>
    </div>
  );
}
